import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { CustomButton } from "components/CustomButton";
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';

function ModalSimplifiedWarning({ open, handleClose, onConfirm, }) {

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ backdropFilter: 'blur(2px)', }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          maxWidth: 504,
          bgcolor: '#FFFFFF',
          p: '25px',
          borderRadius: '10px',
          gap: '30px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box display="flex" alignItems="center" gap="20px" justifyContent="space-between" width='100%' flexDirection='column'>
          <Box component="i" className="icon-alerta_modal" sx={{ color: "#F8BB86", fontSize: '70px ', paddingBottom: '10px' }} />
          <Typography variant="body1" color="#5D5D5D" fontSize="15px" textAlign="center">
            Para acessar essa área, é preciso manter seu cadastro atualizado. <br />
            Atualize agora e aproveite todos os benefícios!
          </Typography>

        </Box>

        <Box display="flex" justifyContent="center" width="100%" gap='15px'>
          <CustomButton
            size="sm"
            fullWidth
            variant="contained"
            style={{ maxWidth: '174px' }}
            defaultColor="#5CB860"
            onClick={onConfirm}
          >
            Atualizar
          </CustomButton>
          <CustomButton
            size="sm"
            fullWidth
            variant="outlined"
            style={{ maxWidth: '174px', borderColor: '#ffffff' }}
            defaultColor="#F05B4F"
            onClick={handleClose}
          >
            Deixar para depois
          </CustomButton>

        </Box>


      </Box>
    </Modal>
  );
}


export default React.memo(ModalSimplifiedWarning)